<template>
  <div>
    <Navbar ref="navbarRef" :selectedOption="1" />
    <h4></h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Genero</th>
          <th scope="col">Edad</th>
          <th scope="col">PesoP3</th>
          <th scope="col">PesoP15</th>
          <th scope="col">PesoP50</th>
          <th scope="col">PesoP85</th>
          <th scope="col">PesoP97</th>
          <th scope="col">TallaP3</th>
          <th scope="col">TallaP15</th>
          <th scope="col">TallaP50</th>
          <th scope="col">TallaP85</th>
          <th scope="col">TallaP97</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="medidaref in datosPaginados" :key="medidaref.idMedidaRef">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(medidaref.idMedidaRef)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(medidaref.idMedidaRef)" title="Editar">edit_square</i></td>
          <td>{{medidaref.genero}}</td>
          <td>{{medidaref.edad}}</td>
          <td>{{medidaref.pesoP3}}</td>
          <td>{{medidaref.pesoP15}}</td>
          <td>{{medidaref.pesoP50}}</td>
          <td>{{medidaref.pesoP85}}</td>
          <td>{{medidaref.pesoP97}}</td>
          <td>{{medidaref.tallaP3}}</td>
          <td>{{medidaref.tallaP15}}</td>
          <td>{{medidaref.tallaP50}}</td>
          <td>{{medidaref.tallaP85}}</td>
          <td>{{medidaref.tallaP97}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteMedidaRef(medidaref.idMedidaRef)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idMedidaRef" class="form-label">IdMedidaRef</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedidaRef" name="idMedidaRef" v-model="datoMedidaRef.idMedidaRef" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="genero" class="form-label">Genero</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="genero" name="genero" v-model="datoMedidaRef.genero" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="edad" class="form-label">Edad</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="edad" name="edad" v-model="datoMedidaRef.edad" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="pesoP3" class="form-label">PesoP3</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="pesoP3" name="pesoP3" v-model="datoMedidaRef.pesoP3" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="pesoP15" class="form-label">PesoP15</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="pesoP15" name="pesoP15" v-model="datoMedidaRef.pesoP15" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="pesoP50" class="form-label">PesoP50</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="pesoP50" name="pesoP50" v-model="datoMedidaRef.pesoP50" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="pesoP85" class="form-label">PesoP85</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="pesoP85" name="pesoP85" v-model="datoMedidaRef.pesoP85" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="pesoP97" class="form-label">PesoP97</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="pesoP97" name="pesoP97" v-model="datoMedidaRef.pesoP97" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tallaP3" class="form-label">TallaP3</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tallaP3" name="tallaP3" v-model="datoMedidaRef.tallaP3" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tallaP15" class="form-label">TallaP15</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tallaP15" name="tallaP15" v-model="datoMedidaRef.tallaP15" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tallaP50" class="form-label">TallaP50</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tallaP50" name="tallaP50" v-model="datoMedidaRef.tallaP50" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tallaP85" class="form-label">TallaP85</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tallaP85" name="tallaP85" v-model="datoMedidaRef.tallaP85" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tallaP97" class="form-label">TallaP97</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tallaP97" name="tallaP97" v-model="datoMedidaRef.tallaP97" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarMedidaRef" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditMedidaRef" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js'
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
      medidarefs : [],
      datoMedidaRef : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.navbarRef.toggleProcesos()
    this.$refs.navbarRef.toggleReportes()
    this.$refs.navbarRef.toggleParametros()
    this.$refs.navbarRef.toggleAyuda()
  },
  methods : {
    totalPaginas(){
      return Math.ceil(this.medidarefs.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwmedidarefs/nombre/'+this.nombreBusqueda).then(response=>{
          this.medidarefs=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.medidarefs.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwmedidarefs').then(response=>{
      this.medidarefs=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.medidarefs.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'genero'
        ,'edad'
        ,'pesoP3'
        ,'pesoP15'
        ,'pesoP50'
        ,'pesoP85'
        ,'pesoP97'
        ,'tallaP3'
        ,'tallaP15'
        ,'tallaP50'
        ,'tallaP85'
        ,'tallaP97'
      ];
      const requiredFieldsText = [
        'genero'
        ,'edad'
        ,'pesoP3'
        ,'pesoP15'
        ,'pesoP50'
        ,'pesoP85'
        ,'pesoP97'
        ,'tallaP3'
        ,'tallaP15'
        ,'tallaP50'
        ,'tallaP85'
        ,'tallaP97'
      ];
      return validarForm(this.datoMedidaRef, requiredFields, requiredFieldsText);
    },
    async guardarMedidaRef(){
      if(this.validarForm() === 1){
        try {
          await api.post('/medidarefs', this.datoMedidaRef)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "MedidaRef creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditMedidaRef(){
      if(this.validarForm() === 1){
        try {
          await api.post('/medidarefs', this.datoMedidaRef)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "MedidaRef creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoMedidaRef={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idMedidaRef){
      this.modalWindow = true
      if(idMedidaRef != null){    
           api.get('/vwmedidarefs/'+idMedidaRef).then(resp=>{
          this.datoMedidaRef = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idMedidaRef){
      if(idMedidaRef != null){
        this.$router.push('/medidarefmd/'+idMedidaRef)
      }
    },
    async deleteMedidaRef (idMedidaRef) {
      try{
        await api.delete('/medidarefs/'+idMedidaRef)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
